import clsx from "clsx";
import React, { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { VehicleInfo } from "../../../queries/useGetVehicleInfo";
import { PackagePartItem } from "../../../queries/useSearchPartPackagesByVehicle";
import { Pagination } from "../../../ui/Pagination/Pagination";
import { NoData } from "../../NoData/NoData";
import { useVisualizerProductId } from "../../Visualizer/useVisualizer";
import { PackageTileRow } from "./PackageTileRow";

const placeholder = [null, null, null, null, null, null];

type PackageResultsProps = {
  hasVisualizer: boolean;
  parts?: PackagePartItem[];
  vehicleInfo?: VehicleInfo;
};

export const PackageList: FunctionComponent<PackageResultsProps> = ({
  hasVisualizer,
  parts = placeholder,
  vehicleInfo,
}) => {
  const { t } = useTranslation();
  const [selectedProductId, setSelectedProducId] =
    useVisualizerProductId(parts);
  const hasColorCodes = Number(vehicleInfo?.vehicleColourCodes.length) > 0;
  return (
    <section
      className={clsx(
        "grid gap-2 md:gap-3 lg:gap-4 xl:gap-6 mt-2 md:mt-4 xl:mt-6"
        // "sm:grid-cols-2 xl:grid-cols-3"
      )}
    >
      <Pagination
      //  className="sm:col-span-2 xl:col-span-3"
      >
        {parts.map((product, key) => (
          <PackageTileRow
            onSelect={
              hasVisualizer && hasColorCodes ? setSelectedProducId : null
            }
            selected={
              hasVisualizer &&
              selectedProductId === product?.partDetails.primaryPart.itemId
            }
            key={product?.partDetails?.primaryPart?.itemId || key}
            part={product}
            vehicleId={vehicleInfo?.vehicleId}
          />
        ))}
      </Pagination>
      {parts.length === 0 && (
        <NoData className="col-span-3">{t("searchResults.noData")}</NoData>
      )}
    </section>
  );
};
